import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Models from "@/pages/Models";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import FAQ from "@/pages/FAQ";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import BoatsAdmin from "@/pages/admin/BoatsAdmin";
import FAQAdmin from "@/pages/admin/FAQAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import ContactsAdmin from "@/pages/admin/ContactsAdmin";
import UsersAdmin from "@/pages/admin/UsersAdmin";
import ContentAdmin from "@/pages/admin/ContentAdmin";

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/models" element={<PublicLayout><Models /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
          <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
          <Route path="/testimonials" element={<PublicLayout><Testimonials /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/boats" element={<BoatsAdmin />} />
          <Route path="/admin/faq" element={<FAQAdmin />} />
          <Route path="/admin/gallery" element={<GalleryAdmin />} />
          <Route path="/admin/testimonials" element={<TestimonialsAdmin />} />
          <Route path="/admin/contacts" element={<ContactsAdmin />} />
          <Route path="/admin/users" element={<UsersAdmin />} />
          <Route path="/admin/content" element={<ContentAdmin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
